import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const Wrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`;

export const imageStyle = css`
	opacity: 0;
	transition: opacity 0.1s;

	&.v {
		opacity: 1;
	}
`;

export const blurredImageStyle = css`
	position: absolute !important;
	top: 0 !important;
	left: 0 !important;
	width: 100% !important;
	height: 100% !important;
	filter: blur(10px);
`;
